var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.4245 0H0.575424V78.8633L48 100.444L95.4245 78.8633V0Z",
    fill: "#D5241A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9780_38158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8136 69.5009H20.3748L19.982 70.6315H18.1588L20.6621 64.1318H22.5263L25.0296 70.6315H23.2064L22.8136 69.5009ZM22.3622 68.2197L21.5942 66.0568L20.8262 68.2197H22.3622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8295 64.1318H29.3738C29.9776 64.1318 30.4349 64.2768 30.7515 64.5609C31.0681 64.8508 31.2205 65.2625 31.2205 65.8019C31.2205 66.132 31.1618 66.3987 31.0446 66.6193C30.9274 66.8337 30.7456 67.0192 30.4994 67.1642C30.7456 67.2107 30.9508 67.28 31.1208 67.373C31.2908 67.4656 31.4315 67.5818 31.537 67.7209C31.6426 67.86 31.7188 68.0164 31.7657 68.1846C31.8126 68.3587 31.836 68.5443 31.836 68.7354C31.836 69.0427 31.7833 69.3094 31.6777 69.5473C31.5722 69.7849 31.4198 69.9823 31.2263 70.1446C31.0329 70.3069 30.7925 70.4286 30.517 70.5039C30.2415 70.5791 29.9248 70.6256 29.5731 70.6256H26.8295V64.1318ZM28.5413 66.6832H28.8579C29.3914 66.6832 29.6611 66.4744 29.6611 66.0568C29.6611 65.6392 29.3914 65.4248 28.8579 65.4248H28.5413V66.6832ZM28.5413 69.3212H28.9165C29.3445 69.3212 29.6552 69.2688 29.8428 69.1589C30.0304 69.0486 30.1242 68.8748 30.1242 68.631C30.1242 68.3875 30.0304 68.2137 29.8428 68.1034C29.6552 67.9935 29.3504 67.9411 28.9165 67.9411H28.5413V69.3212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.845 69.5009H35.4061L35.0134 70.6315H33.1901L35.6876 64.1318H37.5518L40.0551 70.6315H38.2319L37.845 69.5009ZM37.3877 68.2197L36.6197 66.0568L35.8517 68.2197H37.3877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5667 66.6426H46.0349V64.1318H47.7467V70.6315H46.0349V67.9529H43.5667V70.6315H41.8607V64.1318H43.5667V66.6426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1681 70.6315V64.1318H53.926V65.5639H51.8741V70.6315H50.1681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8704 69.5009H57.4317L57.0389 70.6315H55.2156L57.7189 64.1318H59.5832L62.0864 70.6315H60.2631L59.8704 69.5009ZM59.419 68.2197L58.651 66.0568L57.883 68.2197H59.419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5982 70.6315H63.8921V64.1318H66.6124C67.3509 64.1318 67.9138 64.3233 68.3066 64.6999C68.6993 65.077 68.8929 65.6163 68.8929 66.3062C68.8929 66.996 68.6993 67.5294 68.3066 67.9124C67.9138 68.2949 67.345 68.4805 66.6124 68.4805H65.5982V70.6315ZM65.5982 67.1177H66.1667C66.7941 67.1177 67.1107 66.8455 67.1107 66.3062C67.1107 65.7668 66.7941 65.4946 66.1667 65.4946H65.5982V67.1177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0913 69.1995C71.314 69.1995 71.4546 69.1356 71.5251 69.008C71.5953 68.8804 71.6247 68.6893 71.6247 68.4458V64.1318H77.0124V69.1995H77.839V71.8434H76.1388V70.6256H72.1876V71.8434H70.4875V69.1995H71.0913ZM75.3003 65.5639H73.3308V68.4631C73.3308 68.631 73.3249 68.7704 73.3189 68.8863C73.3074 69.0021 73.2898 69.1065 73.2604 69.205H75.3003V65.5639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7008 30.3896H25.6187L30.3462 33.9399H38.4696L39.7008 30.3896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5421 39.748L39.2443 40.6349L39.5421 39.748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2969 30.3896L57.5244 33.9399H65.6514L70.3789 30.3896H56.2969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3202 36.1357L59.202 38.8001L62.6534 36.1357H58.3202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6465 36.1357L36.7646 38.8001L33.3133 36.1357H37.6465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1 56.6715L47.9974 14.3867L33.898 56.6715L39.2756 52.8921L47.9974 25.8206L56.574 52.7895L62.1 56.6715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4255 43.0895L48.0733 42.043L46.5793 43.1648L44.6427 49.1742L48.0733 46.7663L51.3552 49.0716L49.4255 43.0895Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9780_38158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.6803,
    height: 57.5489,
    fill: "white",
    transform: "translate(18.1588 14.3867)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldLogo);
export default __webpack_public_path__ + "static/media/shield-logo.70e8c386.svg";
export { ForwardRef as ReactComponent };